import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { isNotEmpty } from '@hsp/utilities';

import { sharedABQueryKeys } from 'pages/audience/shared/utilities';
import { userService } from 'services';
import { IAudience } from 'types/api/audience';
import { IResult } from 'types/api/common';

export const createAudienceQuery = (
  id: string
): UseQueryOptions<IResult<IAudience> | undefined, unknown, IAudience | undefined> => {
  return {
    enabled: isNotEmpty(id),
    queryFn: async () => await userService.getAudience(id),
    queryKey: sharedABQueryKeys.audience(id),
    select: (data) => data?.dataContainer ?? undefined,
  };
};

export const useFetchAudience = (id: string) => {
  return useQuery(createAudienceQuery(id));
};
